var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemMoreHorizontal = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M4.222 10a2.223 2.223 0 1 1-.001 4.446A2.223 2.223 0 0 1 4.222 10M12 10a2.223 2.223 0 1 1-.002 4.446A2.223 2.223 0 0 1 12 10m7.778 0a2.223 2.223 0 1 1-.002 4.446A2.223 2.223 0 0 1 19.778 10"
})));
export default SvgGemMoreHorizontal;